import { Skeleton } from "@/components/ui/skeleton";

export default function OrderDetailsSkeleton() {
  return (
    <div className="p-6 space-y-6">
      {/* Header */}
      <div className="space-y-2">
        <Skeleton className="h-7 w-40" />
        <Skeleton className="h-5 w-56" />
      </div>

      {/* Customer Details Section */}
      <div className="space-y-2">
        <Skeleton className="h-5 w-32" />
        <div className="rounded-lg border border-neutral-700 bg-[#262626] p-4 space-y-3">
          <Skeleton className="h-4 w-32" />
          <Skeleton className="h-4 w-40" />
          <Skeleton className="h-4 w-36" />
          <Skeleton className="h-4 w-64" />
        </div>
      </div>

      {/* Item Details Section */}
      <div className="space-y-2">
        <Skeleton className="h-5 w-32" />
        <div className="rounded-lg border border-neutral-700 bg-[#262626] overflow-hidden">
          <div className="grid grid-cols-[3fr,1fr,1fr] gap-4 p-3 border-b border-neutral-700">
            <Skeleton className="h-4 w-20" />
            <Skeleton className="h-4 w-16" />
            <Skeleton className="h-4 w-16" />
          </div>
          <div className="divide-y divide-neutral-700">
            {[...Array(3)].map((_, i) => (
              <div key={i} className="p-3 space-y-2">
                <div className="grid grid-cols-[3fr,1fr,1fr] gap-4">
                  <Skeleton className="h-4 w-32" />
                  <Skeleton className="h-4 w-12" />
                  <Skeleton className="h-4 w-16" />
                </div>
                <Skeleton className="h-3 w-24" />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Payment Details Section */}
      <div className="space-y-2">
        <Skeleton className="h-5 w-32" />
        <div className="rounded-lg border border-neutral-700 bg-[#262626] p-4 space-y-3">
          <div className="flex justify-between">
            <Skeleton className="h-4 w-24" />
            <Skeleton className="h-4 w-16" />
          </div>
          <div className="flex justify-between">
            <Skeleton className="h-4 w-24" />
            <Skeleton className="h-4 w-16" />
          </div>
          <div className="flex justify-between">
            <Skeleton className="h-4 w-24" />
            <Skeleton className="h-4 w-16" />
          </div>
          <div className="pt-3 mt-3 border-t border-neutral-700 flex justify-between items-center">
            <Skeleton className="h-6 w-16" />
            <div className="text-right space-y-1">
              <Skeleton className="h-4 w-24" />
              <Skeleton className="h-6 w-32" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
